import React, { useState } from "react"
import axios from "axios"

import { toCamelCase } from "@utils/toCamelCase"

import { TextInput } from "@components/common/form/TextInput"
import { DropDown } from "@components/common/form/DropDown"
import { CheckBox } from "@components/common/form/CheckBox"
import { TextArea } from "@components/common/form/TextArea"
import { Cta } from "@components/common/cta/Cta"

import * as s from "./CompetitionForm.module.scss"

export const CompetitionForm = ({ data }) => {
  const {
    competition,
    title,
    introText,
    postTitle,
    postText,
    formBuilder,
    formLayout,
  } = data

  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const [sendError, setSendError] = useState(false)

  const initialFormState = {}

  formBuilder?.forEach(element => {
    initialFormState[toCamelCase(element.label)] = {
      value: "",
      required: element.required,
      errored: false,
    }
    if (
      element.fieldGroupName ===
      "ContentNode_Flexiblecontent_Content_CompetitionForm_FormBuilder_EmailInput"
    ) {
      initialFormState[toCamelCase(element.label)].pattern =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  })
  const [formValue, setFormValue] = useState(initialFormState)

  const submitEntry = async () => {
    if (sending) return
    setSending(true)
    setSendError(false)
    let hasError = false

    const _formVal = { ...formValue }

    Object.keys(_formVal).forEach(function (item) {
      const field = _formVal[item]
      if (field.required && !field.value) {
        hasError = true
        _formVal[item].errored = true
      } else {
        _formVal[item].errored = false
      }

      if (field.required && field.pattern) {
        if (!field.pattern.test(String(field.value).toLowerCase())) {
          hasError = true

          _formVal[item].errored = true
        } else {
          _formVal[item].errored = false
        }
      }
    })
    setFormValue(_formVal)

    if (hasError) {
      setSending(false)
    } else {
      //SEND
      try {
        const bodyFormData = new FormData()
        Object.keys(formValue).forEach(function (item) {
          const formValueWithFill = formValue[item].value
            ? formValue[item].value
            : "-"
          bodyFormData.append(item, formValueWithFill)
        })

        bodyFormData.append("comp-id", competition.databaseId)

        /*eslint-disable*/
        const contactRes = await axios.post(
          `https://${process.env.GATSBY_WORDPRESS_BASE_URL}/wp-json/competition/v1/entry`,
          bodyFormData,
          { headers: { "Content-Type": "multipart/form-data" } },
        )
        setSent(true)
        setSending(false)
      } catch (e) {
        setSendError(true)
        setSending(false)
      }
      /*eslint-enable*/
    }
  }

  return (
    <div
      className={`${s.wrapper} ${
        formLayout === "fullWidth" ? s.fullWidth : ""
      }`}
      id="compForm"
    >
      {sent ? (
        <div className={s.introText}>
          <h4>{postTitle}</h4>
          <div dangerouslySetInnerHTML={{ __html: postText }}></div>
        </div>
      ) : (
        <>
          <div className={s.introText}>
            <h4>{title}</h4>
            <div dangerouslySetInnerHTML={{ __html: introText }}></div>
          </div>
          <div className={s.formWrapper}>
            {formBuilder?.map((element, i) => {
              switch (element.fieldGroupName) {
                case "ContentNode_Flexiblecontent_Content_CompetitionForm_FormBuilder_TextInput":
                  return (
                    <div
                      className={`${element.halfWidth ? s.half : s.full}`}
                      key={`text-${i}`}
                    >
                      <TextInput
                        placeholder={element.label}
                        value={formValue[toCamelCase(element.label)].value}
                        error={formValue[toCamelCase(element.label)].errored}
                        onChange={e => {
                          setFormValue({
                            ...formValue,
                            [toCamelCase(element.label)]: {
                              ...formValue[toCamelCase(element.label)],
                              value: e.target.value,
                            },
                          })
                        }}
                      />
                    </div>
                  )
                case "ContentNode_Flexiblecontent_Content_CompetitionForm_FormBuilder_EmailInput":
                  return (
                    <div
                      className={`${element.halfWidth ? s.half : s.full}`}
                      key={`email-${i}`}
                    >
                      <TextInput
                        placeholder={element.label}
                        value={formValue[toCamelCase(element.label)].value}
                        error={formValue[toCamelCase(element.label)].errored}
                        onChange={e => {
                          setFormValue({
                            ...formValue,
                            [toCamelCase(element.label)]: {
                              ...formValue[toCamelCase(element.label)],
                              value: e.target.value,
                            },
                          })
                        }}
                      />
                    </div>
                  )
                case "ContentNode_Flexiblecontent_Content_CompetitionForm_FormBuilder_TextArea":
                  return (
                    <div className={s.full} key={`textarea-${i}`}>
                      <TextArea
                        placeholder={element.label}
                        value={formValue[toCamelCase(element.label)].value}
                        error={formValue[toCamelCase(element.label)].errored}
                        onChange={e => {
                          setFormValue({
                            ...formValue,
                            [toCamelCase(element.label)]: {
                              ...formValue[toCamelCase(element.label)],
                              value: e.target.value,
                            },
                          })
                        }}
                      />
                    </div>
                  )
                case "ContentNode_Flexiblecontent_Content_CompetitionForm_FormBuilder_SelectField":
                  return (
                    <div className={s.full} key={`select-${i}`}>
                      <DropDown
                        placeholder={element.label}
                        value={formValue[toCamelCase(element.label)].value}
                        error={formValue[toCamelCase(element.label)].errored}
                        options={element.options.map(opt => {
                          return {
                            label: opt.label,
                            value: toCamelCase(opt.label),
                          }
                        })}
                        onChange={value => {
                          setFormValue({
                            ...formValue,
                            [toCamelCase(element.label)]: {
                              ...formValue[toCamelCase(element.label)],
                              value: value,
                            },
                          })
                        }}
                      />
                    </div>
                  )
                case "ContentNode_Flexiblecontent_Content_CompetitionForm_FormBuilder_Checkbox":
                  return (
                    <div className={s.full} key={`checkbox-${i}`}>
                      <div className={s.check}>
                        <CheckBox
                          value={formValue[toCamelCase(element.label)].value}
                          error={formValue[toCamelCase(element.label)].errored}
                          onChange={value => {
                            setFormValue({
                              ...formValue,
                              [toCamelCase(element.label)]: {
                                ...formValue[toCamelCase(element.label)],
                                value: value,
                              },
                            })
                          }}
                        />
                        <span>{element.label}</span>
                      </div>
                    </div>
                  )
                default:
                  break
              }
            })}

            <div className={s.entrySubmit}>
              <Cta title={"Submit"} onClick={submitEntry} />
            </div>
          </div>
        </>
      )}

      {sendError && (
        <div className={s.sendError}>
          <p>There has been an error. Please try again.</p>
        </div>
      )}
    </div>
  )
}
